export class BaseCryptoUtils {
    static TIME_WINDOW_HOURS = 4;
    static MILLISECONDS_PER_HOUR = 60 * 60 * 1000;
    static DYNAMIC_KEY_LENGTH = 16;
    static USER_AGENT_SLICE_LENGTH = 10;
    static CRYPTO_KEY_STORAGE = '__ibk_crypto_key__';
    static IV_LENGTH = 12;
    static AES_KEY_LENGTH = 256;
    getObfuscatedKey() {
        const userAgent = navigator.userAgent.slice(0, BaseCryptoUtils.USER_AGENT_SLICE_LENGTH);
        const domain = window.location.hostname;
        const timeWindow = Math.floor(Date.now() / (BaseCryptoUtils.TIME_WINDOW_HOURS * BaseCryptoUtils.MILLISECONDS_PER_HOUR));
        const dynamicKey = btoa(`ibk-${userAgent}-${domain}-${timeWindow}`).slice(0, BaseCryptoUtils.DYNAMIC_KEY_LENGTH);
        return dynamicKey;
    }
    performXorOperation(text, key) {
        let result = '';
        for (let i = 0; i < text.length; i++) {
            const charCode = text.charCodeAt(i) ^ key.charCodeAt(i % key.length);
            result += String.fromCharCode(charCode);
        }
        return result;
    }
    simpleEncrypt(text, key) {
        const xorResult = this.performXorOperation(text, key);
        return btoa(xorResult);
    }
    simpleDecrypt(encryptedText, key) {
        try {
            const decoded = atob(encryptedText);
            return this.performXorOperation(decoded, key);
        }
        catch {
            throw new Error('Failed to decrypt data');
        }
    }
    clearCryptoKeys() {
        try {
            window.localStorage.removeItem(BaseCryptoUtils.CRYPTO_KEY_STORAGE);
        }
        catch (error) {
            console.warn('Error clearing encryption keys:', error);
        }
    }
    handleError(operation, context, error) {
        const errorMessage = `Failed to ${operation} ${context}`;
        console.error(`${errorMessage}:`, error);
        throw new Error(errorMessage);
    }
}
